import { render, staticRenderFns } from "./returnPremium.vue?vue&type=template&id=e99468f8&scoped=true&"
import script from "./returnPremium.vue?vue&type=script&lang=js&"
export * from "./returnPremium.vue?vue&type=script&lang=js&"
import style0 from "./returnPremium.vue?vue&type=style&index=0&id=e99468f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99468f8",
  null
  
)

export default component.exports